export const createGroupText = `Click the 'Create Group' button below to create a new rule group
  or select from the list on the left of the existing ones to edit a rule group.`;

export const nameRulesText = "Name your new rule and then click next to begin creating a new rule.";

export const nameGroupText = `Name your new rule group, give a description,
  then click next to begin adding facilities to the group.`;
